// extracted by mini-css-extract-plugin
export default {"quantumButton":"quantumButton--ORAyZ"};